module.exports = __webpack_public_path__ + "static/media/07.59649bfb.png";